export default __webpack_public_path__ + "static/media/googleHover.31763855.svg";